import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const ErrorMessage: FC<{
  className?: string;
  message: string;
}> = ({ message, className }) => {
  const { t } = useTranslation();

  return (
    <div className={`mt-1 flex flex-nowrap justify-between ${className}`}>
      <span className="helper-text helper-text--error">{t(message)}</span>
    </div>
  );
};

export const extractErrorMessage = (error: {
  message?: string | { i18nKey: string };
}): [string, any] => {
  if (typeof error?.message === 'string') {
    return [error.message, {}];
  }

  const { i18nKey, ...rest } = error?.message || {
    i18nKey: 'label.defaultError',
  };

  return [i18nKey, rest];
};
